// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "aeaf12f";
